/*
 * Noble Designs: minimum order quantity support (5.6 agency feature) for the 8.3.2 product page and cart page.
 * Quantity inputs carry data-nd-min (from the inventory.minimum_quantity metafield). The stock 8.3 quantity
 * controls only know a minimum of 1, so this clamps them. Listeners are delegated on the document (capture
 * phase, so they run before the theme's own handlers) and work after theme-editor section reloads.
 */
(() => {
  if (window.ndMainMinQty) return;
  window.ndMainMinQty = true;

  const minOf = (input) => parseInt(input.dataset.ndMin, 10) || 1;
  const isCartInput = (input) => input.classList.contains('cart-item__quantity-input');

  const updateDownState = (input) => {
    if (isCartInput(input)) return;
    const wrapper = input.closest('quantity-wrapper');
    const down = wrapper && wrapper.querySelector('[data-quantity="down"]');
    if (down) down.classList.toggle('nd-main-qty-down--disabled', (parseInt(input.value, 10) || 0) <= minOf(input));
  };

  const clamp = (input) => {
    const min = minOf(input);
    const value = parseInt(input.value, 10);
    if (isCartInput(input)) {
      // 0 removes the line item, anything else must reach the minimum
      if (!Number.isNaN(value) && value > 0 && value < min) input.value = min;
    } else if (Number.isNaN(value) || value < min) {
      input.value = min;
    }
    updateDownState(input);
  };

  document.addEventListener('change', (evt) => {
    const input = evt.target;
    if (input instanceof HTMLInputElement && input.matches('input[data-nd-min]')) clamp(input);
  }, true);

  // Cart page: stop the decrease button going below the minimum
  document.addEventListener('click', (evt) => {
    const down = evt.target.closest && evt.target.closest('.cart-item .quantity-down');
    if (!down) return;
    const input = down.closest('.cart-item').querySelector('.cart-item__quantity-input[data-nd-min]');
    if (!input) return;
    const value = parseInt(input.value, 10) || 0;
    if (value - 1 > 0 && value - 1 < minOf(input)) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }, true);

  // Product page: on variant change, start the quantity at the new variant's minimum (as 5.6 did)
  document.addEventListener('on:variant:change', (evt) => {
    const scope = (evt.target && evt.target.closest && evt.target.closest('.js-product')) || document;
    scope.querySelectorAll('input[name="quantity"][data-nd-min]').forEach((input) => {
      if (input.dataset.ndMinApplied !== input.dataset.ndMin) {
        input.value = minOf(input);
        input.dataset.ndMinApplied = input.dataset.ndMin;
      }
      clamp(input);
    });
  });
})();
